import { computed, reactive, toRefs } from "vue";
import { fetchData } from "../services";
const initialState = {
    items: [],
    filteredItems: [],
    displayedItems: [],
    selectedTopics: null,
    dateRange: [],
    loading: false,
    count: undefined,
    itemsPerPage: 10,
    currentIndex: 0,
    dateFilterInputs: [
        { id: "fl_2_1", label: 'timeItems_inputs_start_label', datetype: "Start", classes: "", placeholder: 'timeItems_inputs_start_placeholder', value: "" },
        { id: "fl_2_2", label: 'timeItems_inputs_end_label', datetype: "Stop", classes: "", placeholder: 'timeItems_inputs_end_placeholder', value: "" }
    ]
};
export function useNewsFilter() {
    const state = reactive(initialState);
    async function fetchNews({ url, pastYears, archive, mandatoryTopics }) {
        if (!url) {
            throw Error('API Url is not provided!');
        }
        state.loading = true;
        let data = await fetchData(url, pastYears, archive, mandatoryTopics);
        state.loading = false;
        if (data) {
            state.items = data;
            state.filteredItems = data;
            state.count = data.length;
            loadMore();
        }
    }
    function dateFilter(filtered, lng) {
        const [startDate, endDate] = state.dateRange;
        if (startDate && endDate) {
            const parseDate = (dateString) => {
                const dateParts = lng === "DE" ? dateString.split('.') : dateString.split('/');
                if (dateParts.length !== 3) {
                    throw new Error(`Invalid date format: ${dateString}`);
                }
                const [day, month, year] = dateParts.map(part => parseInt(part, 10));
                return new Date(Date.UTC(year, month - 1, day)); // Create UTC formated date
            };
            const normalizeDateUTC = (date) => {
                return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
            };
            const parsedStartDate = normalizeDateUTC(parseDate(startDate));
            const parsedEndDate = normalizeDateUTC(parseDate(endDate));
            return filtered.filter(item => {
                const itemStartDate = normalizeDateUTC(new Date(item.date));
                const itemEndDate = item.dateEnd ? normalizeDateUTC(new Date(item.dateEnd)) : null;
                if (itemEndDate) {
                    return ((itemStartDate <= parsedEndDate && itemStartDate >= parsedStartDate) || // Is start date in date range?
                        (itemEndDate >= parsedStartDate && itemEndDate <= parsedEndDate) || // Is end date in date range?
                        (itemStartDate <= parsedStartDate && itemEndDate >= parsedEndDate) // Does Event completley include in selected date range?
                    );
                }
                return itemStartDate >= parsedStartDate && itemStartDate <= parsedEndDate;
            });
        }
        return filtered;
    }
    function topicFilter(filtered) {
        if (state.selectedTopics?.length) {
            const selectedTopicsId = state.selectedTopics.map(topic => topic.id);
            return filtered.filter((item) => item.topics.some(topic => selectedTopicsId.includes(topic)));
        }
        return filtered;
    }
    function applyFilters(lng = "DE") {
        let filtered = [...state.items];
        filtered = topicFilter(filtered);
        filtered = dateFilter(filtered, lng);
        state.filteredItems = filtered;
        state.count = filtered.length;
        state.displayedItems = [];
        state.currentIndex = 0;
        loadMore();
    }
    function clearFilter() {
        state.selectedTopics = null;
        state.dateRange = [];
        state.filteredItems = [...state.items];
        state.count = state.items.length;
        state.displayedItems = [];
        state.currentIndex = 0;
        clearDateInputs();
        loadMore();
    }
    function clearDateInputs() {
        state.dateFilterInputs.forEach(input => input.value = "");
    }
    function getFormattedDateRange() {
        const [startDate, endDate] = state.dateRange;
        return {
            startDate,
            endDate
        };
    }
    function loadMore() {
        const start = state.currentIndex;
        const end = start + state.itemsPerPage;
        state.displayedItems = [
            ...state.displayedItems,
            ...state.filteredItems.slice(start, end)
        ];
        state.currentIndex = end;
    }
    const canLoadMore = computed(() => state.currentIndex < state.filteredItems.length);
    return {
        ...toRefs(state),
        fetchNews,
        applyFilters,
        clearFilter,
        clearDateInputs,
        getFormattedDateRange,
        loadMore,
        canLoadMore
    };
}
